<template>
	<div>
		<div class="row mb-2">

			<div class="col-sm-3">
				<div class="text-sm-left">
					<div class="btn-group mb-3">
						<button v-if="!loading" type="button" class="btn btn-primary" @click="getData()">Обновить</button>
						<button v-else class="btn btn-primary" type="button" disabled>
							<span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
							Загрузка...
						</button>
					</div>
				</div>
			</div>

			<div class="col-sm-9">
				<div class="text-sm-right">
					<div class="btn-group mb-3 mr-2">
						<button type="button" class="btn" :class="filter.page === 'all' ? 'btn-dark' : 'btn-light'"
							@click="filter.page = 'all'">Все</button>
						<button type="button" class="btn" :class="filter.page === 'not_managed' ? 'btn-dark' : 'btn-light'"
							@click="filter.page = 'not_managed'">
							Непрочитанные
							<span class="badge badge-pill badge-outline-info" v-if="items && notManagedCount">{{
								notManagedCount }}</span>
						</button>
						<button type="button" class="btn" :class="filter.page === 'managed' ? 'btn-dark' : 'btn-light'"
							@click="filter.page = 'managed'">Прочитанные</button>
					</div>

					<!-- <div class="btn-group mb-3 mr-2">
						<button type="button" class="btn" :class="filter.page === 'spam' ? 'btn-dark' : 'btn-light'"
							@click="filter.page = 'spam'">
							Спам
							<span class="badge badge-pill badge-outline-info" v-if="items && spamCount">{{ spamCount
							}}</span>
						</button>
					</div> -->

					<div class="btn-group mb-3">
						<button type="button" class="btn" :class="filter.page === 'deleted' ? 'btn-dark' : 'btn-light'"
							@click="filter.page = 'deleted'">Удаленные</button>
					</div>
				</div>
			</div><!-- end col-->
		</div>
		<!-- end row-->

		<div class="row" v-if="items == null">
			<div class="col-md-12 text-center">
				<div class="spinner-grow" role="status">
					<span class="sr-only">Loading...</span>
				</div>
			</div>
		</div>

		<div class="row" v-else>
			<table class="table  table-centered table-responsive-md mb-0">
				<thead>
					<tr>
						<th>ID</th>
						<th>Имя</th>
						<th>Сообщение</th>

						<th>EMail</th>
						<th>Телефон</th>
						<th>Способ связи</th>

						<!-- <th>Тип объекта</th>
						<th>Площадь / Комнат</th> -->

						<th>IP</th>

						<th>Дата</th>

						<th>Scores</th>
						<th></th>
					</tr>
				</thead>
				<transition-group name="list" tag="tbody">
					<tr v-for="(item, i) in filteredItems" :key="i" :class="{ 'bg-light': !item.managed }">
						<td>{{ item._id }}</td>
						<td style="max-width: 500px; word-break: break-all;">{{ item.feedback.name }}</td>
						<td style="max-width: 500px; word-break: break-all;">{{ item.feedback.object_message || '-' }}</td>

						<td style="max-width: 500px; word-break: break-all;">{{ item.feedback.email }}</td>
						<td style="max-width: 500px; word-break: break-all;">{{ item.feedback.phone }}</td>
						<td>{{ app_mongo_desc.feedbackDescription.contactMethod[item.feedback.contactMethod] }}</td>

						<!-- <td>{{ item.feedback.object_type ?
							app_mongo_desc.feedbackDescription.object_type[item.feedback.object_type] : '-' }}</td>
						<td>{{ item.feedback.object_square ? item.feedback.object_square : '-' }} / {{
							item.feedback.object_rooms ? item.feedback.object_rooms : '-' }}</td> -->

						<td> {{ item.city ? item.city : '-' }} / {{ item.country ? item.country : '-' }} </td>

						<td>{{ formatDate(item.createdAt) }}</td>

						<td>
							<span title="captchaScore"> {{ item.captchaScore }} </span> / <span title="adminScore"> {{
								item.adminScore }} </span>
						</td>

						<td>
							<button v-if="!item.managed" class="btn btn-sm btn-rounded btn-info"
								@click="manageItem(item._id, true)"><span class="uil-envelope-open"></span>
								Прочитала</button>
							<button v-else class="btn btn-sm btn-rounded btn-outline-info"
								@click="manageItem(item._id, false)"><span class="uil-envelope-redo"></span>
								Отложить</button>

							<!-- <button v-if="item.isSpam" class="btn btn-sm btn-rounded btn-secondary ml-1"
								@click="spamItem(item._id, false)">Не спам</button>
							<button v-else class="btn btn-sm btn-rounded btn-outline-secondary ml-1"
								@click="spamItem(item._id, true)">спам</button> -->

							<button v-if="item.deleted" class="btn btn-sm btn-rounded btn-outline-warning ml-1"
								@click="restoreItem(item._id)">восстановить</button>
							<button v-else class="btn btn-sm btn-rounded btn-outline-danger ml-1"
								@click="deleteItem(item._id)"><span title="удалить" class="uil-trash-alt"></span></button>
						</td>
					</tr>
				</transition-group>
			</table>
		</div>

	</div>
</template>

<script>
import { mapState } from 'vuex'
import log from '@/plugins/log'
import { to } from '@/plugins/utils'
import * as dayjs from 'dayjs'

import localizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/ru'

dayjs.extend(localizedFormat)
dayjs.locale('ru')

export default {
	name: 'FeedbackList',
	data: () => {
		return {
			form: null,
			items: null,
			loading: false,
			filter: {
				page: 'not_managed'
			}
		}
	},
	computed: {
		...mapState([
			'app_mongo_desc'
		]),
		filteredItems() {
			return this.items.filter(item => {
				if (item.deleted == true && this.filter.page == 'deleted') return true
				if (item.deleted) return false

				//if (item.isSpam == true && this.filter.page == 'spam') return true
				//if (item.isSpam) return false

				if (this.filter.page == 'all') return true
				if (this.filter.page == 'managed' && item.managed === true) return true
				if (this.filter.page == 'not_managed' && item.managed === false) return true

				return false
			})
		},
		notManagedCount() {
			return this.items.reduce((acc, item) => {
				return acc + (!item.isSpam && !item.deleted && item.managed == false ? 1 : 0)
			}, 0)
		},
		spamCount() {
			return this.items.reduce((acc, item) => {
				return acc + (item.isSpam && item.managed == false ? 1 : 0)
			}, 0)
		}
	},
	beforeMount() {
		this.getData()
	},
	mounted() {
		log.debug('/views/feedback/list', 'mounted')
	},
	watch: {
		'form.url': function (newVal, oldVal) {
			this.form.url_slug = cyr2lat(newVal).toLocaleLowerCase()
		}
	},
	methods: {
		async getData() {
			this.loading = true
			var [err, response] = await to(this.$http.get('/feedback/list'))
			setTimeout(() => {
				this.loading = false
			}, 500)

			if (err) {
				log.error('/views/feedback/list', 'methods.getData', '$http.request', err)
				return $.NotificationApp.send("Ошибка", "Не удалось получить данные", "top-right", "", "error")
			}
			log.debug('/views/feedback/list', 'methods.getData', '$http.request', response.data)

			this.items = response.data.items
		},

		async manageItem(id, status) {
			var [err, response] = await to(this.$http.post(`/feedback/edit/${id}`, {
				managed: !!status
			}))
			if (err) {
				log.error(`/views/feedback/edit/${id}`, 'methods.manageItem', '$http.request', err)
				return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
			}

			log.debug(`/views/feedback/edit/${id}`, 'methods.manageItem', '$http.request', response.data)

			this.getData()
		},

		async spamItem(id, status) {
			var [err, response] = await to(this.$http.post(`/feedback/edit/${id}`, {
				adminScore: status ? -10 : 10
			}))
			if (err) {
				log.error(`/views/feedback/edit/${id}`, 'methods.spamItem', '$http.request', err)
				return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
			}

			log.debug(`/views/feedback/edit/${id}`, 'methods.spamItem', '$http.request', response.data)

			this.getData()
		},


		async deleteItem(id) {
			if (!confirm('Уверены, что хотите удалить?')) return;

			var [err, response] = await to(this.$http.post(`/feedback/delete/${id}`))
			if (err) {
				log.error('/views/feedback/list', 'methods.deleteItem', '$http.request', err)
				return $.NotificationApp.send("Ошибка", "Не удалось получить данные", "top-right", "", "error")
			}
			if (!response.data.success) {
				log.error('/views/feedback/list', 'methods.deleteItem', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}
			log.debug('/views/feedback/list', 'methods.deleteItem', '$http.request', response.data)

			this.getData()
		},
		async restoreItem(id) {
			var [err, response] = await to(this.$http.post(`/feedback/restore/${id}`))
			if (err) {
				log.error('/views/feedback/list', 'methods.restoreItem', '$http.request', err)
				return $.NotificationApp.send("Ошибка", "Не удалось получить данные", "top-right", "", "error")
			}
			if (!response.data.success) {
				log.error('/views/feedback/list', 'methods.restoreItem', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}
			log.debug('/views/feedback/list', 'methods.restoreItem', '$http.request', response.data)

			this.getData()
		},

		formatDate(date) {
			return dayjs(date).format('LLL')
		},
	}
};
</script>
<style>
.list-move {
	transition: transform .15s ease-in-out;
}

.list-enter-active,
.list-leave-active {
	transition: opacity .3s ease;
}

.list-enter,
.list-leave-to {
	opacity: 0;
}
</style>